import "@adeccoux/tag-ds/index.css";
import React from "react";

const Base = ({ children }) => {
    return <section>{children}</section>;
};

export default Base;
